import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { EntityContainer } from 'src/app/tools/models/entityContainer';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { PriceList } from 'src/app/assabil-kernel/models/entities/master-data/price-list-entity';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { Field } from 'src/app/tools/models/dtos/field';
import { ProductLovComponent } from '../product-lov/product-lov.component';


@Component({
  selector: 'price-list-list',
  templateUrl: './price-list-list.component.html',
  styleUrls: ['./price-list-list.component.scss']
})


export class PriceListListComponent extends BasePage2<PriceList>   {

  initEntityContainer() {
    this.entityContainer = new EntityContainer(PriceList);
  }

  getRows(){
    return this.priceLists;
  }

  priceListCode         : string;
  showInMap             : boolean = false;
  priceLists            : PriceList[] = [];

  priceListLineFields         : Field[];
  priceListLineDetailFields   : Field[];


 //--------------------------------------------------------------------------------------------------------------------------------------
 constructor(
    protected masterDataService : MasterDataService, 
    protected toastr            : ToastrService,
    protected router            : Router,
    protected baseService       : BaseService,
    protected leanUtilsService  : LeanUtilsService, 
    protected location          : Location) {
   
       super(toastr, router, baseService, leanUtilsService, location);

       this.entityName = 'priceList';

       this.baseService.fieldsGet("priceListLine").then(result => {
        this.priceListLineFields = result.listFields;
        this.baseService.fieldsGet("priceListLineDetail").then(result => {
          this.priceListLineDetailFields = result.listFields;
          for (let field of this.priceListLineDetailFields ){
            if (field.prop == 'product') {
              field.modal = ProductLovComponent;
              field.subProp = 'codeName';
            }
          }
        })
      })
  }
//--------------------------------------------------------------------------------------------------------------------------------------
  

//--------------------------------------------------------------------------------------------------------------------------------------
  loadData() {
    this.masterDataService.priceListsGet(this.priceListCode).then(result => {
      this.priceLists = result;
    })
  }
//--------------------------------------------------------------------------------------------------------------------------------------
  
  
//--------------------------------------------------------------------------------------------------------------------------------------
  selectRow(priceList : PriceList){
    let index : number = this.priceLists.indexOf(priceList);
    this.masterDataService.priceListGet(priceList.priceListCode, false).then(priceList => {
      this.priceLists[index] = priceList;
      this.selectedRow = priceList; 
      })
  }
//--------------------------------------------------------------------------------------------------------------------------------------
  
}

